import {
  INVOICE_UPLOAD_ACCEPTED_TYPES,
  INVOICE_UPLOAD_MAX_FILE_SIZE,
} from '../constants/constants';

export const formatDate = dateStr => {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return dateStr;
  }
};

export const formatCurrency = val => {
  if (val == null) return '-';
  return `\u00a3${val.toFixed(2)}`;
};

export const formatFileSize = bytes => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const validateFile = file => {
  if (!INVOICE_UPLOAD_ACCEPTED_TYPES.includes(file.type)) {
    return `${file.name}: unsupported format. Use PDF, JPEG, PNG, or WebP.`;
  }
  if (file.size > INVOICE_UPLOAD_MAX_FILE_SIZE) {
    return `${file.name}: file too large (${formatFileSize(
      file.size
    )}). Maximum is 20 MB.`;
  }
  return null;
};
